


























import { defineComponent, toRefs, unref } from '@vue/composition-api';
import WaitForLoading from '@berlin-front/common/components/clusters/WaitForLoading';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import { useContext } from '@berlin-front/common/composables/context';
import { ModalHeaderContext } from '@services/ModalHeaderContext';

import { HEADER_TYPE } from '@berlin-front/common/components/clusters/ModalHeader/composable';
import { bemx } from '@berlin-front/common/utils';
import { LoadingContext } from './context';

export default defineComponent({
  name: 'LoadingView',
  components: {
    AppCard,
    ModalHeader,
    WaitForLoading,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useLoading } = useContext(LoadingContext);
    const { onComplete, isCompleted, isLoading, title, duration } = toRefs(useLoading());

    const headerClass = bemx('Loading_Header', { hidden: unref(title).length === 0 });

    return {
      isCompleted,
      isLoading,
      onComplete,
      title,
      duration,

      headerClass,

      HEADER_TYPE,
    };
  },
});
